import * as React from 'react'
import { applyPatch } from 'mobx-state-tree'
import { SettingsBreadcrumbs } from '../settings-breadcrumbs'
import { SettingsTitle } from 'components/settings-title'
import { HealthAuditSettingsForm } from './form'
import { store } from 'store/index'

export type HealthAuditSettingsPageProps = {
  calledBy: string
  organisationString: string
  enableHealthAudit: boolean
  showAlertsInTeamManagement: boolean
  healthAuditCheckSettings: Record<string, boolean>
}

export const HealthAuditSettingsPage = (
  props: HealthAuditSettingsPageProps,
) => {
  const {
    calledBy,
    organisationString,
    enableHealthAudit,
    showAlertsInTeamManagement,
    healthAuditCheckSettings,
  } = props

  React.useEffect(() => {
    const org = store.currentUser?.org
    if (!org) return
    applyPatch(org, [
      { op: 'replace', path: '/enableHealthAudit', value: enableHealthAudit },
    ])
  }, [enableHealthAudit])

  return (
    <div className="pb-16">
      <SettingsBreadcrumbs breadcrumbs={[organisationString, 'Health Audit']} />
      <SettingsTitle>Health Audit</SettingsTitle>

      <HealthAuditSettingsForm
        calledBy={calledBy}
        enableHealthAudit={enableHealthAudit}
        showAlertsInTeamManagement={showAlertsInTeamManagement}
        healthAuditCheckSettings={healthAuditCheckSettings}
      />
    </div>
  )
}
